var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ykc-detail-plus',{staticClass:"box-card",attrs:{"labelWidth":150}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("驳回原因")])]),_c('ykc-detail-item-plus',{attrs:{"label":"驳回原因","prop":"name"}},[_c('div',[_vm._v(_vm._s(_vm.info.reason || '——'))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }